import React from 'react'
import User from '@commons/users'
import { verificationRequest } from '@assets/icons'
import UserProfile from '@components/userprofile'
import dayjs from 'dayjs'

const RejectedRequest = () => {
  const column = [
    { title: 'S.N', key: 'sn', render: (_item, index) => index },
    {
      title: 'Provider',
      key: 'provider',
      render: (item) => <UserProfile item={item} role="operator" />,
    },
    { title: 'Email', key: 'email', render: (item) => item.email || 'N/A' },
    {
      title: 'Company Name',
      key: 'companyName',
      render: (item) => item?.infos?.companyInfos?.companyName || 'N/A',
    },
    {
      title: 'Company Contact',
      key: 'companyContact',
      render: (item) =>
        item?.infos?.companyInfos?.companyContactNumber || 'N/A',
    },
    {
      title: 'Requested Date',
      key: 'requestedDate',
      render: (item) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            {item.createdAt
              ? dayjs(item.createdAt).format('DD MMM YYYY')
              : 'N/A'}
          </span>
          <span style={{ fontSize: '0.85rem', color: '#666' }}>
            {item.createdAt ? dayjs(item.createdAt).format('HH:mm:ss') : ''}
          </span>
        </div>
      ),
    },
  ]
  return (
    <User
      icon={verificationRequest}
      title="Verification Request"
      columns={column}
      role="operator"
      status="Rejected"
    />
  )
}

export default RejectedRequest
